import { render } from "./account-info-edit.vue?vue&type=template&id=b5eff6de"
import script from "./account-info-edit.vue?vue&type=script&lang=js"
export * from "./account-info-edit.vue?vue&type=script&lang=js"

import "./account-info-edit.vue?vue&type=style&index=0&id=b5eff6de&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__